// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aa7c3c9a","794":"a9562cc7"}[chunkId] + ".chunk.js";
};